import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../core/modules/shared.module';
import {AuthGuard} from '../../../data/services/authGuard';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import {ProgressComponent} from './progress.component';

const routes = [
  {path: 'progress', component: ProgressComponent, canActivate: [AuthGuard]}
];

@NgModule({
  declarations: [ProgressComponent],
  imports: [SharedModule, RouterModule.forChild(routes), NgxChartsModule],
  exports: [ProgressComponent]
})

export class FuseProgressModule {}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/progress/progress.module.ts